export const positionOptions = [
  { value: "CTO", label: "CTO" },
  { value: "Manager", label: "Manager" },
  { value: "Director", label: "Director" },
  { value: "Recruiter", label: "Recruiter" },
  { value: "Team Lead", label: "Team Lead" },
  { value: "Senior Executive", label: "Senior Executive" },
  { value: "CFO", label: "CFO" },
  { value: "Business Owner", label: "Business Owner" },
  { value: "Entrepreneur", label: "Entrepreneur" },
  { value: "Managing Director", label: "Managing Director" },
  { value: "Project Manager", label: "Project Manager" },
];

export const workModeOptions = [
  { value: "Onsite", label: "Onsite" },
  { value: "Remote", label: "Remote" },
  { value: "Relocation", label: "Relocation" },
  { value: "Hybrid", label: "Hybrid" },
];
export const workTypeOptions = [
  { value: "Part-Time", label: "Part-Time" },
  { value: "Full-Time", label: "Full-Time" },
  { value: "Internship", label: "Internship" },
];

export const locationOptions = [];

export const industryOptions = [
  {
    value: "Information Technology (Software, Data, Cloud, AI)",
    label: "Information Technology (Software, Data, Cloud, AI)",
  },
  {
    value: "Product Management & Design",
    label: "Product Management & Design",
  },
  {
    value: "Digital Marketing & Communications",
    label: "Digital Marketing & Communications",
  },
  {
    value: "Business & Strategy Consulting",
    label: "Business & Strategy Consulting",
  },
  {
    value: "Financial Services (Banking, Investment, FinTech)",
    label: "Financial Services (Banking, Investment, FinTech)",
  },
  {
    value: "Human Resources & Recruitment",
    label: "Human Resources & Recruitment",
  },
  {
    value: "Project & Operations Management",
    label: "Project & Operations Management",
  },
  { value: "Legal & Compliance", label: "Legal & Compliance" },
  {
    value: "Cybersecurity & IT Infrastructure",
    label: "Cybersecurity & IT Infrastructure",
  },
  {
    value: "Quality Assurance & Testing",
    label: "Quality Assurance & Testing",
  },
  {
    value: "Civil & Structural Engineering",
    label: "Civil & Structural Engineering",
  },
  {
    value: "Electrical & Mechanical Engineering",
    label: "Electrical & Mechanical Engineering",
  },
  { value: "Oil, Gas & Energy", label: "Oil, Gas & Energy" },
  {
    value: "Renewable Energy & Sustainability",
    label: "Renewable Energy & Sustainability",
  },
  { value: "Manufacturing & Production", label: "Manufacturing & Production" },
  { value: "Construction & Real Estate", label: "Construction & Real Estate" },
  { value: "Transportation & Logistics", label: "Transportation & Logistics" },
  { value: "Advertising & Branding", label: "Advertising & Branding" },
  {
    value: "Content Creation & Copywriting",
    label: "Content Creation & Copywriting",
  },
  {
    value: "Film, Animation & Multimedia Production",
    label: "Film, Animation & Multimedia Production",
  },
  {
    value: "Public Relations & Corporate Communications",
    label: "Public Relations & Corporate Communications",
  },
  { value: "UI/UX & Visual Design", label: "UI/UX & Visual Design" },
  {
    value: "Sales & Business Development",
    label: "Sales & Business Development",
  },
  {
    value: "Customer Service & Call Center",
    label: "Customer Service & Call Center",
  },
  {
    value: "Administrative & Executive Support",
    label: "Administrative & Executive Support",
  },
  { value: "Procurement & Supply Chain", label: "Procurement & Supply Chain" },
  { value: "Retail & E-commerce", label: "Retail & E-commerce" },
  {
    value: "Entrepreneurship & Startups",
    label: "Entrepreneurship & Startups",
  },
  {
    value: "Healthcare & Pharmaceuticals",
    label: "Healthcare & Pharmaceuticals",
  },
  { value: "Education & Training", label: "Education & Training" },
  {
    value: "Government & Public Administration",
    label: "Government & Public Administration",
  },
  { value: "NGOs & Development", label: "NGOs & Development" },
  { value: "Research & Policy", label: "Research & Policy" },
  { value: "Agritech & Food Production", label: "Agritech & Food Production" },
  {
    value: "ClimateTech & Environmental Management",
    label: "ClimateTech & Environmental Management",
  },
  {
    value: "Travel, Tourism & Hospitality",
    label: "Travel, Tourism & Hospitality",
  },
  {
    value: "Real Estate & Facility Management",
    label: "Real Estate & Facility Management",
  },
  { value: "TransportTech / Mobility", label: "TransportTech / Mobility" },
  {
    value: "Entertainment & Sports Management",
    label: "Entertainment & Sports Management",
  },
];
